module.exports = __webpack_public_path__ + "static/sponsorkliks-logo-999da28286666d5021e736b3755fee30.svg";